import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SearchCriteriaComponent } from "./search-criteria/search-criteria.component";
import { SearchResultComponent } from "./search-result/search-result.component";
import { ApprovedListComponent } from "./approved-list/approved-list.component";
import { SearchCriteriaUSTCRComponent } from "./ust-cr/search-criteria-ust-cr/search-criteria-ust-cr.component";
import { SearchResultUSTCRComponent } from "./ust-cr/search-result-ust-cr/search-result-ust-cr.component";

export const CommonRoute: Routes = [
  {
    path: "cgp",
    children: [
      {
        path: "search-criteria",
        component: SearchCriteriaComponent,
        data: {
          title: "NOI CONSTRUCTION STORMWATER PERMIT SEARCH",
          placeBarRequired: false,
          showSaveAndExit: false,
          showReviewComments: false,
          isLandingPage: false,
        },
      },
      {
        path: "approved-list",
        component: ApprovedListComponent,
        data: {
          title: "NOI CONSTRUCTION STORMWATER PERMIT SEARCH",
          placeBarRequired: false,
          showSaveAndExit: false,
          showReviewComments: false,
          isLandingPage: false,
        },
      },
      {
        path: "search-result",
        component: SearchResultComponent,
        data: {
          title: "NOI CONSTRUCTION STORMWATER PERMIT SEARCH",
          placeBarRequired: false,
          showSaveAndExit: false,
          showReviewComments: false,
          isLandingPage: false,
        },
      },
    ],
  },
  {
    path: "lust",
    children: [
      {
        path: "search-criteria",
        component: SearchCriteriaUSTCRComponent,
        data: {
          title: "UST CR SEARCH",
          placeBarRequired: false,
          showSaveAndExit: false,
          showReviewComments: false,
          isLandingPage: false,
        },
      },
      {
        path: "cases/:releaseIdno",
        component: SearchResultUSTCRComponent,
        data: {
          title: "UST CR SEARCH",
          placeBarRequired: false,
          showSaveAndExit: false,
          showReviewComments: false,
          isLandingPage: false,
        },
      },
    ],
  },
];

export const commonRouting: ModuleWithProviders<RouterModule> =
  RouterModule.forRoot(CommonRoute, {});
